import { Component } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';
import { SpinnerService } from './api/module/erp/shared/services/spinner-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ERPGeia';

  // mensagem spinner
  mensagemSpinner$ = this._spinnerService.mensagem$;

  constructor(
    private _spinnerService: SpinnerService,
    private ngSelectConfig: NgSelectConfig,
  ) {
    this.ngSelectConfig.notFoundText = 'Nenhum item encontrado';
    this.ngSelectConfig.clearAllText = 'Limpar tudo';
    this.ngSelectConfig.placeholder = 'Selecione...';
  }
}
